import Vue from "vue";
import { ModalPlugin } from "bootstrap-vue";
import VueMaterial from "vue-material";
import nouislider from "nouislider";
import wNumb from "wnumb";
import VueMeta from "vue-meta";
import VueIframe from 'vue-iframes'

Vue.use(VueIframe)

import {
  MdButton,
  MdContent,
  MdTabs,
  MdProgress,
  MdIcon,
  MdDialog
} from "vue-material/dist/components";
import IrealVue from "ireal-vue";
import config from "./config";
import IrealMixin from "./ireal-mixin";
import RadialGauge from "canvas-gauges";

Vue.use(MdButton);
Vue.use(MdContent);
Vue.use(MdTabs);
Vue.use(MdIcon);
Vue.component(MdProgress);
Vue.use(MdDialog);
Vue.use(VueMeta);
/* en cas de réutilisation: (plugin pour générer un toogle button dans vuejs):
import ToggleButton from "vue-js-toggle-button";
*/
// FONTAWESOME:
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { faBars, faQuestion, faPlay, faPause, faForward, faBackward, faCheckDouble } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

//import "bootstrap-vue/dist/bootstrap-vue.min.css";
import "./assets/style.css";
import "vue-material/dist/vue-material.min.css";
import "./assets/material-kit-pro/assets/scss/material-kit.scss";
import "./assets/vue-material-kit-pro/src/assets/scss/material-kit.scss";
import "material-design-icons/iconfont/material-icons.css";
import globalDirectives from "vue-material-kit-pro/src/plugins/globalDirectives.js";
Vue.use(globalDirectives);
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueEllipseProgress from 'vue-ellipse-progress';
 
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.use(VueEllipseProgress);

Vue.config.productionTip = false;

//library.add(faBars, faQuestion, faPlay, faPause, faForward, faBackward, faCheckDouble);
//Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueMaterial);
Vue.use(wNumb);
Vue.use(ModalPlugin);
Vue.use(IrealVue, config);
Vue.use(IrealMixin, config);
Vue.use(RadialGauge);
Vue.use(nouislider);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
